<template>
  <div class="text-white relative shadow-md">
    <img
      alt="reserve icon"
      class="h-20 sm:h-40 w-full object-cover"
      src="@/assets/reserve.png"
    />
    <hr
      class="h-20 sm:h-40 w-full bg-gradient-to-t from-black absolute top-0"
    />
    <div class="absolute top-0 sm:top-10 w-full text-left p-2">
      <p class="font-bold text-xl">Reservations</p>
      <div class="flex">
        <p class="text-gray-50 text-xs flex-1">
          You can reserve a table with us.<br />{{ $store.state.phone1 }},
          {{ $store.state.phone2 }}
        </p>
        <p
          @click="call"
          :href="'tel:' + $store.state.phone1"
          class="m-2 text-lg px-2 rounded-md font-semibold bg-bnb-mustard"
        >
          Call Now
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    call() {
      document.location.href = "tel:" + this.$store.state.phone1;
    },
  },
};
</script>
